import 'core-js';
import 'fetch-polyfill';
import 'url-search-params-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'mobx-react';
import { ConfigProvider } from 'm-ui';
import zhCN from 'm-ui/es/locale/zh_CN';
import { Provider as ReduxProvider } from 'react-redux';
import store from 'redux/store';
import models from 'models';
import { createBrowserHistory } from 'history';
import { init } from '@ad/uc';
import { renderRoutes } from 'react-router-config';
import routes from './router';
import moment from 'moment';
import 'utils/axios';
import 'utils/sentry';
import 'utils/login';
import 'moment/locale/zh-cn';
import 'assets/css/common.less';
import 'm-ui/dist/m-ui.less';
import 'intro.js/introjs.css';
import 'styles/index.less';
import '@ad/message-center/lib/index.css';
import { initDMPLog } from 'utils/businesslog';
import './blankMonitor';
import { Robot } from 'component/Robot';
import { isEmbedIntoPlatform } from 'utils/embed';
// import Feedback from 'modules/feedback/Feedback';
import { KmiProvider } from '@kmi/react';
import { RouterPath } from './constants/constants';

// 本地化日期
moment.locale('zh-cn');

if (window.location.hostname === 'dmp.e.kuaishou.com') {
    window.location.href = 'https://wanxiang.e.kuaishou.com/';
}

export const history = createBrowserHistory();

const ifShowRobot = !isEmbedIntoPlatform();

const env = {
    production: 'production',
    beta: 'beta',
    development: 'test',
    staging: 'staging',
};

export const uc = init({
    sid: 'kuaishou.ad.dsp',
    env: env[process.env.REACT_APP_RUN_ENV],
    history,
    appKey: 'ad.adUkmConfig.adDmp',
    interceptorAccount: {
        callback: undefined,
        whiteList: [/\w+\.kuaishou.com/, /\w+\.kuaishou.cn/], // UC 登录组件在多账号的场景劫持了__accountId__，UC 登录组件默认的白名单配置不含 .cn ，导致 __accountId__ 丢失，初期方案可以前端增加配置做兼容，后期 UC 组件会做统一兼容。
        loginUrl: '/',
    },
    interceptorUnLogged: {
        loginUrl: RouterPath.FRONT_PAGE,
        intercept109: false,
    },
});

// 初始化各页面 PV 埋点
initDMPLog();

render(
    <KmiProvider>
        <ConfigProvider locale={zhCN}>
            <ReduxProvider store={store}>
                <Provider {...models}>
                    <Router history={history}>
                        <div onClickCapture={uc.onRootClick}>{renderRoutes(routes)}</div>
                        {ifShowRobot ? <Robot /> : null}
                        {/* <Feedback /> 下线问卷调研*/}
                    </Router>
                </Provider>
            </ReduxProvider>
        </ConfigProvider>
    </KmiProvider>,
    document.querySelector('#app'),
);
